import { render, staticRenderFns } from "./ReplacementsTable.vue?vue&type=template&id=287f7045&scoped=true"
import script from "./ReplacementsTable.vue?vue&type=script&lang=js"
export * from "./ReplacementsTable.vue?vue&type=script&lang=js"
import style0 from "./ReplacementsTable.vue?vue&type=style&index=0&id=287f7045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287f7045",
  null
  
)

export default component.exports